import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useOktaAuth } from "@okta/okta-react";
//import { useUser } from './UserContext';
import { apiGatewayConfig } from '../config';
import { invokeLambda } from '../api';


// Create context
const ReferentialsContext = createContext();

// Custom hook for using referentials
export const useReferentials = () => {
  const context = useContext(ReferentialsContext);
  if (!context) {
    throw new Error('useReferentials must be used within a ReferentialsProvider');
  }
  return context;
};

// Provider component
export const ReferentialsProvider = ({ children }) => {
  const [referentials, setReferentials] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const { oktaAuth } = useOktaAuth();

  const loadReferentials = useCallback(async () => {
    if (isLoading || referentials) return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointJobAdReferentials, {}, {});
      
      if (response.statusCode === 200) {
        setReferentials(response.referentials);
      } else {
        setError(response);
        console.error("Error loading referentials:", response);
      }
    } catch (error) {
      setError(error);
      console.error('Error invoking Lambda:', error);
    } finally {
      setIsLoading(false);
    }
  }, [oktaAuth, isLoading, referentials]);

  // Load referentials on first render
  useEffect(() => {
    loadReferentials();
  }, [loadReferentials]);

  // Reload function for manual reloading when needed
  const reloadReferentials = useCallback(() => {
    setReferentials(null);
    loadReferentials();
  }, [loadReferentials]);

  const value = {
    referentials,
    isLoading,
    error,
    reloadReferentials
  };

  return (
    <ReferentialsContext.Provider value={value}>
      {children}
    </ReferentialsContext.Provider>
  );
};